import React, { useEffect } from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { useBusinessModel } from "../businessModel";
import useNavModel from "@/model/navModel";
import { momentFormat } from "@/utils/utils";
import { loadFileUrl } from "@/utils/constants";
import { Image } from 'antd';
import { IBusinessDetail } from "../businessTypes";

export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg, selectedRow,
        loadData, setSelectedRowKeys, setSelectedRow,
        initCategory
    } = useBusinessModel();
    const { selectedNavId, replaceNav } = useNavModel();
    const columns: ColumnsType<IBusinessDetail> = [
        {
            title: '序号',
            width: 60,
            fixed: "left",
            render: (text, record, index) => `${index + 1}`
        }, {
            title: '业务范围',
            width: 160,
            fixed: "left",
            dataIndex: 'columnName'
        }, {
            title: '简介',
            width: 250,
            fixed: "left",
            dataIndex: 'intro',
        }, {
            title: '合作品牌',
            width: 160,
            dataIndex: 'coopStatus',
            render: (v) => v === 1 ? '已开启' : '未开启'
        }, {
            title: '业务资质',
            width: 160,
            dataIndex: 'businessStatus',
            render: (v) => v === 1 ? '已开启' : '未开启'
        }, {
            title: '荣誉奖章',
            width: 160,
            dataIndex: 'medalStatus',
            render: (v) => v === 1 ? '已开启' : '未开启'
        }, {
            title: '服务案例',
            width: 200,
            dataIndex: 'serviceStatus',
            render: (v) => v === 1 ? '已开启' : '未开启'
        }, {
            title: '创建人',
            width: 160,
            dataIndex: 'createUser',
        }, {
            title: '创建时间',
            width: 160,
            dataIndex: 'createTime',
            render: (text) => momentFormat(text)
        },
    ];
    useEffect(() => {
        loadData()
        initCategory()
    }, []);

    //点击行选高亮
    const onRow = (record: IBusinessDetail) => {
        // let findIndex = selectedRowKeys.indexOf(id);
        let { id } = record as { id: string };
        let findIndexDesc = selectedRow.findIndex((item) => (item.id === id));
        let newDescRows = [...selectedRow];
        let newSelectedRowKeys = [...selectedRowKeys];

        if (findIndexDesc === -1) {
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
            //表格选中值
            newDescRows.push(record);
            setSelectedRow(newDescRows);
        } else {
            newSelectedRowKeys.splice(findIndexDesc, 1);
            setSelectedRowKeys(newSelectedRowKeys);
            //表格选中值
            newDescRows.splice(findIndexDesc, 1);
            setSelectedRow(newDescRows);
        }
    };
    const onRightClick = (record: IBusinessDetail) => {
        setSelectedRow([record]);
        setSelectedRowKeys([record.id as string])
    }
    return (
        <Table
            rowKey={record => record.id as string}
            rowSelection={{
                selectedRowKeys: selectedRowKeys, //记录选中
                onChange: (selectedRowKeys: React.Key[], selectedRows: IBusinessDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys as string[]);
                    setSelectedRow(selectedRows)
                }
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record),
                onContextMenu: (e) => {
                    e.preventDefault();
                    onRightClick(record)
                }
            })}
            scroll={{ x: 'max-content', y: 500 }}
        />
    )
}
